import {
  Box,
  Button,
  Stack,
  Text,
  Title,
  useComputedColorScheme,
} from "@mantine/core";
import EmailRounded from "@mui/icons-material/EmailRounded";
import Link from "next/link";
import { CSSProperties } from "react";
import EmailVerificationBanner from "../../../public/static/images/permissions/emailverificationbanner.svg";
import { useAccessBannerStyles } from "./NoAccess";

export default function NotVerified() {
  const { classes } = useAccessBannerStyles();
  const colorScheme = useComputedColorScheme("light");
  const toColor =
    colorScheme === "dark"
      ? "var(--mantine-color-blue-6)"
      : "var(--mantine-color-darkblue-6)";
  return (
    <Stack className={classes.wrapper}>
      <Title
        order={2}
        className={classes.title}
        style={
          {
            "--banner-title-gradient": `linear-gradient(180deg, var(--mantine-color-lightblue-6) 0%, ${toColor} 100%)`,
          } as CSSProperties
        }
      >
        Verification Required
      </Title>
      <Box className={classes.imgWrapper} mx={"auto"}>
        <EmailVerificationBanner />
      </Box>
      <Text className={classes.text}>
        You must <span className={classes.highlight}>verify your email</span> to
        enable access to these IB resources!
      </Text>
      <Text className={classes.text}>
        <span className={`${classes.highlight} ${classes.highlight2}`}>
          Check your inbox (and junk)
        </span>{" "}
        for an email from us. All you have to do is{" "}
        <span className={`${classes.highlight} ${classes.highlight2}`}>
          click the link
        </span>
        !
      </Text>
      <Button
        className={classes.button}
        component={Link}
        href={"/profile/account"}
        color="lightblue"
        size="md"
        leftSection={<EmailRounded />}
      >
        Request New Link
      </Button>
    </Stack>
  );
}
